import axios from 'axios'

let _socketUrl = null
let _token = null
let _projectId = null
let _socket = null

const heartbeatTimeout = 45000
let _heartbeatTimeoutId = null
let _tryReconnectTimeoutId = null

const _serverPushPrefix = 'ServerPush_'
const _requestPrefix = 'Request_'
let _listenerMap = new Map()

const sendHeartbeat = () => {
  if (_socket) {
    const heartbeatData = { clientType: 1, type: 90000 }
    $socket.sendData(heartbeatData)
    _heartbeatTimeoutId = setTimeout(sendHeartbeat, heartbeatTimeout)
  }
}

const tryReconnect = () => {
  _token && $socket.connect(_token, _projectId)
}

const socketOpened = e => {
  console.log('socket opened')
  _heartbeatTimeoutId = setTimeout(sendHeartbeat, heartbeatTimeout)
}

const socketMessageReceived = messageEvent => {
  try {
    const data = JSON.parse(messageEvent.data)
    if (data) {
      if (data.type === '10001') {
        $socket.close()
      } else {
        if (!data.responseId) {
          const key = generateServerPushKey(data.type)
          let listenerObject = _listenerMap.get(key)
          if (listenerObject) {
            for (const callback of listenerObject.callbackList) {
              callback(data)
            }
          }
        } else {

        }
      }
    }
  } catch (e) {
    console.log(e)
  }
}

const socketClosed = e => {
  console.log('socket closed')
  _heartbeatTimeoutId && clearTimeout(_heartbeatTimeoutId)
  if (_socket && _token) {
    _tryReconnectTimeoutId = setTimeout(tryReconnect, 3000)
  }
}

const socketErrorCatch = e => {
  console.log(e)
}

window.addEventListener('beforeunload', function () {
  $socket.close()
})

const generateServerPushKey = (type) => {
  return _serverPushPrefix + type
}

const $socket = {
  async connect (token, projectId) {
    console.log('socket connect')
    _token = token
    _projectId = projectId
    if (!_socketUrl) {
      // const response = await axios({ method: 'get', url: window.location.origin + '/static/address.json' })
      // _socketUrl = response.data.data.socketUrl
      _socketUrl = window.ENV.socketUrl
    }
    let wsUrl = `${_socketUrl}notification/1?token=${encodeURIComponent(_token)}`
    if (_projectId) {
      wsUrl += `&projectId=${_projectId}`
    }
    try {
      _socket = new WebSocket(wsUrl)
      _socket.onopen = socketOpened
      _socket.onmessage = socketMessageReceived
      _socket.onclose = socketClosed
      _socket.onerror = socketErrorCatch
    } catch (e) {
      socketClosed(e)
    }
  },
  addListener (type, callback) {
    const key = generateServerPushKey(type)
    let listenerObject = _listenerMap.get(key)
    if (!listenerObject) {
      listenerObject = { callbackList: [] }
      _listenerMap.set(key, listenerObject)
    }
    if (!listenerObject.callbackList.find(item => item === callback)) {
      listenerObject.callbackList.push(callback)
    }
  },
  removeListener (type, callback) {
    const key = generateServerPushKey(type)
    let listenerObject = _listenerMap.get(key)
    if (listenerObject) {
      const index = listenerObject.callbackList.indexOf(callback)
      if (index !== -1) {
        listenerObject.callbackList.splice(index, 1)
      }
    }
  },
  sendData (data) {
    if (_socket) {
      _socket.send(JSON.stringify(data))
    }
  },
  requestData (data) {

  },
  close () {
    console.log('socket close')
    _token = null
    _socket = null
    _heartbeatTimeoutId && clearTimeout(_heartbeatTimeoutId)
    _heartbeatTimeoutId = null
    _tryReconnectTimeoutId && clearTimeout(_tryReconnectTimeoutId)
    _tryReconnectTimeoutId = null
    _socket && _socket.close()
  }
}

export default $socket



// WEBPACK FOOTER //
// ./src/plugins/socket.js